import { linksSearch, getFacetLabelByFacetName } from "../utils/linksSearch";
export const createLabelForFilters = (filter) => {
  return getFacetLabelByFacetName(linksSearch, filter);
};
export const deleteFilter = (url, filter) => {
  return url.replace("&f=" + filter, "");
};
export const addFilter = (url, filter) => {
  return url + `&f=${filter}`;
};
export const addUniqueLetterFilter = (url, filter) => {
  const facet = filter.split(":")[0];
  const value = filter.split(":")[1];

  let regex = new RegExp("&f=" + facet + ":[^\\*]\\*", "g");
  let newUrl = url.replace(regex, "");
  if (value === "*") {
    return newUrl;
  }
  return addFilter(newUrl, filter);
};
